import type { FunctionComponent } from 'react';
import { Box } from '@mantine/core';
import type { CropState } from './EditPhotoContent';
import { zoomToScale } from './EditPhotoContent';

type CroppedImagePreviewProps = {
  imageUrl: string;
  cropState: CropState;
  aspectRatio?: string;
};

export const CroppedImagePreview: FunctionComponent<CroppedImagePreviewProps> = ({
  imageUrl,
  cropState,
  aspectRatio = '4/3',
}) => {
  const { zoom, rotate, cropBox } = cropState;
  const scale = zoomToScale(zoom);

  return (
    <Box
      style={{
        position: 'relative',
        aspectRatio,
        borderRadius: 'var(--mantine-radius-sm)',
        overflow: 'hidden',
        background: 'var(--surface-secondary)',
      }}
    >
      <Box
        style={{
          position: 'absolute',
          width: `${(100 / cropBox.size) * 100}%`,
          height: `${(100 / cropBox.size) * 100}%`,
          left: `${-(cropBox.left / cropBox.size) * 100}%`,
          top: `${-(cropBox.top / cropBox.size) * 100}%`,
        }}
      >
        <img
          src={imageUrl}
          alt=""
          draggable={false}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transform: `scale(${scale}) rotate(${rotate}deg)`,
            transformOrigin: 'center',
            display: 'block',
            pointerEvents: 'none',
          }}
        />
      </Box>
    </Box>
  );
};
